import { type FC, type PropsWithChildren } from 'react'

import { useSrpAds } from '@/components-page/srp/advertisement/useSrpAds'
import { AdsWrapper } from '@/features/advertisement/components/ads-wrapper/AdsWrapper'

type SearchAdsWrapperProps = PropsWithChildren & {
  userAgent?: string
}

export const SearchAdsWrapper: FC<SearchAdsWrapperProps> = ({ children, userAgent }) => {
  const { srpGptConfig } = useSrpAds(userAgent)

  return <AdsWrapper gptConfig={srpGptConfig}>{children}</AdsWrapper>
}
